// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"4c935e87","466":"7bedd510","738":"d78aee85","787":"78f1ee74","856":"19498416"}[chunkId] + ".chunk.js";
};